import React, { useState, useEffect, useRef } from 'react';
import {
  Container,
  Form,
  Button,
  Row,
  Col,
  InputGroup,
  Dropdown,
  Spinner
} from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import SubcategoryService from '../../service/SubcategoryService';
import LocationService from '../../service/LocationService';
import icon1 from '../../assets/icon-one.svg';
import icon2 from '../../assets/icon-two.svg';
import icon3 from '../../assets/icon-three.svg';
import icon4 from '../../assets/icon-four.svg';
import icon5 from '../../assets/icon-five.webp';
import icon6 from '../../assets/icon-six.webp';

const SearchSection = () => {
  const [location, setLocation] = useState('');
  const [subcategories, setSubcategories] = useState([]);
  const [selectedSubcategory, setSelectedSubcategory] = useState('');
  const [locationSuggestions, setLocationSuggestions] = useState([]);
  const [showLocationSuggestions, setShowLocationSuggestions] = useState(false);
  const [showSubcategory, setShowSubcategory] = useState(false);
  const [loading, setLoading] = useState(false);

  const subcategoryRef = useRef(null);
  const locationRef = useRef(null);

  const navigate = useNavigate();

  useEffect(() => {
    fetchData();
  }, []);

  // ✅ Close dropdowns on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        subcategoryRef.current &&
        !subcategoryRef.current.contains(event.target)
      ) {
        setShowSubcategory(false);
      }

      if (
        locationRef.current &&
        !locationRef.current.contains(event.target)
      ) {
        setShowLocationSuggestions(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () =>
      document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const fetchData = async () => {
    try {
      const subcategoriesResponse =
        await SubcategoryService.getSubcategoriesByCategory();
      setSubcategories(subcategoriesResponse);
    } catch (error) {
      console.error('Error fetching subcategories:', error);
    }
  };

  const handleLocationChange = async (e) => {
    const newLocation = e.target.value;
    setLocation(newLocation);

    if (newLocation.length >= 3) {
      setLoading(true);
      setShowLocationSuggestions(true);
      try {
        const response =
          await LocationService.getLocationByName(newLocation);
        setLocationSuggestions(response);
      } catch (error) {
        console.error('Error fetching location suggestions:', error);
        setShowLocationSuggestions(false);
      } finally {
        setLoading(false);
      }
    } else {
      setShowLocationSuggestions(false);
      setLoading(false);
    }
  };

  const handleLocationSelect = (selectedLocation) => {
    setLocation(selectedLocation.location);
    setShowLocationSuggestions(false);
  };

  const handleSubcategorySelect = (subcategory) => {
    setSelectedSubcategory(subcategory);
    setShowSubcategory(false);
  };

  const handleSearch = () => {
    const selectedSubcategoryData = subcategories.find(
      (sub) => sub.name === selectedSubcategory
    );

    if (selectedSubcategoryData) {
      sessionStorage.setItem(
        'subcategoryId',
        selectedSubcategoryData.id
      );
    }

    sessionStorage.removeItem('shopType');

    const formattedSubcategory = selectedSubcategory
      .trim()
      .replace(/\s+/g, '-');

    const searchlocation = location
      .trim()
      .replace(/,\s*/g, '-');

    const url = `/${formattedSubcategory}/service-near-me/${searchlocation}`;
    navigate(url.toLowerCase());
  };

  const handleLinks = (subcategory) => {
    const selectedSubcategoryData = subcategories.find(
      (sub) => sub.name === subcategory
    );

    if (selectedSubcategoryData) {
      sessionStorage.setItem(
        'subcategoryId',
        selectedSubcategoryData.id
      );
    }

    sessionStorage.removeItem('shopType');

    const formattedSubcategory = selectedSubcategoryData?.name
      .trim()
      .replace(/\s+/g, '-');

    const locations = [
      'Phoenix-AZ-USA',
      'Fresno-CA-USA',
      'Dallas-TX-USA',
      'Washington-DC-USA',
      'Beaumont-CA-USA',
      'Dallas-GA-USA'
    ];

    const randomlocation =
      locations[Math.floor(Math.random() * locations.length)];

    const url = `/${formattedSubcategory}/service-near-me/${randomlocation}`;
    navigate(url.toLowerCase());
  };

  return (
    <section className="home_search position-relative">
      <Container>
        <Row className="justify-content-center">
          <Col md={10} sm={12} className="px-md-0 mb-3">
            <h1>Professional Truck & <br/>Trailer Services</h1>
            <h5 className="mb-2">
              Connect with trusted repair shops nationwide
            </h5>
          </Col>
        </Row>

        <Row className="justify-content-center d-md-block d-none">
          <Col md={12} sm={12} className="search_icon px-0 my-4">
            <ul>
              <li>
                <img src={icon1} alt="Truck Repair" />
                <h4>
                  <a onClick={() => handleLinks('Truck Repair')}>
                    Truck Repair
                  </a>
                </h4>
              </li>

              <li>
                <img src={icon2} alt="Trailer Repair" />
                <h4>
                  <a onClick={() => handleLinks('Trailer Repair')}>
                    Trailer Repair
                  </a>
                </h4>
              </li>

              <li>
                <img src={icon3} alt="Tire Repair" />
                <h4>
                  <a
                    onClick={() =>
                      handleLinks('Tire Repair and Sales')
                    }
                  >
                    Tire Repair
                  </a>
                </h4>
              </li>

              <li>
                <img src={icon4} alt="Towing Service" />
                <h4>
                  <a
                    onClick={() =>
                      handleLinks('Towing and Recovery')
                    }
                  >
                    Towing Truck
                  </a>
                </h4>
              </li>
            </ul>
          </Col>
        </Row>

        <Form className="hero-form" onSubmit={handleSearch}>
          <Row className="align-items-center justify-content-center search_input search_input_hero">

            {/* Subcategory */}
            <Col
              md={5}
              sm={12}
              className="category_search"
              ref={subcategoryRef}
            >
              <InputGroup>
                <Form.Control
                  type="text"
                  placeholder="Choose Service"
                  value={selectedSubcategory}
                  onClick={() =>
                    setShowSubcategory((prev) => !prev)
                  }
                  readOnly
                  required
                />
              </InputGroup>

              {showSubcategory && (
                <Dropdown.Menu show className="w-100">
                  {subcategories.map((subcategory) => (
                    <Dropdown.Item
                      key={subcategory.id}
                      onClick={() =>
                        handleSubcategorySelect(subcategory.name)
                      }
                    >
                      {subcategory.name}
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              )}
            </Col>

            {/* Location */}
            <Col
              md={5}
              sm={12}
              className="location_search"
              ref={locationRef}
            >
              <InputGroup>
                <Form.Control
                  type="text"
                  placeholder="Enter your city, state"
                  value={location}
                  onChange={handleLocationChange}
                  required
                />
              </InputGroup>

              {showLocationSuggestions && (
                <Dropdown.Menu show className="w-100">
                  {loading ? (
                    <div className="d-flex justify-content-center mt-4">
                      <Spinner animation="border" />
                    </div>
                  ) : locationSuggestions.length > 0 ? (
                    locationSuggestions.map((suggestion, index) => (
                      <Dropdown.Item
                        key={index}
                        onClick={() =>
                          handleLocationSelect(suggestion)
                        }
                      >
                        {suggestion.location}
                      </Dropdown.Item>
                    ))
                  ) : (
                    <Dropdown.Item disabled>
                      No results found
                    </Dropdown.Item>
                  )}
                </Dropdown.Menu>
              )}
            </Col>

            {/* Search */}
            <Col md={2} sm={12} className="search_btn">
              <Button variant="primary" className="btn-block" type="submit">
                <i className="fa fa-search" /> Search
              </Button>
            </Col>

          </Row>
        </Form>
      </Container>
    </section>
  );
};

export default SearchSection;
